import Button from "@components/Button"
import ForgotPasswordDialog from "@components/ForgotPasswordDialog"
import Input from "@components/Input"
import Layout from "@components/Layout"
import PageHeading from "@components/PageHeading"
import { resetPasswordForEmail } from "@helpers/supabase"
import { validateEmail } from "@helpers/validations"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Form } from "react-router-dom"

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("")
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const { t } = useTranslation()

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    await resetPasswordForEmail({ email })

    setIsDialogOpen(true)
  }

  return (
    <>
      <Layout>
        <div className="space-y-6 text-center">
          <PageHeading>{t("pages.account.forgotPassword.heading")}</PageHeading>

          <p className="custom-subheading">
            {t("pages.account.forgotPassword.enterEmail")}
          </p>
        </div>

        <Form className="custom-form" onSubmit={handleSubmit}>
          <Input
            autoFocus
            onChange={(event) => setEmail(event.target.value)}
            placeholder={t("shared.email")}
            type="email"
            value={email}
          />

          <div className="mt-auto pt-6">
            <Button
              disabled={!validateEmail(email)}
              title={t("pages.account.forgotPassword.resetPassword")}
              type="submit"
            />
          </div>
        </Form>
      </Layout>

      {isDialogOpen && (
        <ForgotPasswordDialog
          open={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
        />
      )}
    </>
  )
}
